import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, FormControl } from '@mui/material';
import { useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { WsTypoVariants, WsTypography } from 'wisestep-base';

import PopoverOnClick from '../../features/clientListingPage/components/PopoverOnClick';

interface ITypeHeaderProps {
  getType: (value: string) => void;
  currentType: string;
  label: string;
  types: string[];
}

const HeaderTypeLayout = ({ getType, currentType, label, types }: ITypeHeaderProps) => {
  const textLabelEl = useRef<HTMLElement | null>(null);
  const defaultValues = {
    type: 'all_types',
  };
  const methods = useForm({
    defaultValues: defaultValues,
  });

  const labelText =
    currentType === 'my_contacts' || currentType === 'my_clients' ? `My ${label}` : `All ${label}`;

  return (
    <FormProvider {...methods}>
      <FormControl>
        <PopoverOnClick
          element={
            <Box ref={textLabelEl} display="flex" alignItems="center">
              <WsTypography variant={WsTypoVariants.TITLE} cursor="pointer">
                {labelText}
              </WsTypography>
              <KeyboardArrowDownIcon />
            </Box>
          }
        >
          {types.map((type) => (
            <Box p={1} key={type}>
              <WsTypography
                variant={WsTypoVariants.SUB_TITLE}
                cursor="pointer"
                onClick={() => {
                  getType(type.toLowerCase().replace(' ', '_'));
                  textLabelEl.current?.click();
                }}
              >
                {type}
              </WsTypography>
            </Box>
          ))}
        </PopoverOnClick>
      </FormControl>
    </FormProvider>
  );
};

export default HeaderTypeLayout;
